(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    
// Optional JavaScript for enhanced functionality
// This runs only if section is present and interactive features are needed

class CustomLiquidSection {
  constructor(section) {
    this.section = section;
    this.container = section.querySelector('.custom-liquid-section__container');
    
    if (this.container) {
      this.init();
    }
  }

  init() {
    // Handle any dynamic content loading if needed
    this.processLiquidOutputs();
    
    // Add resize listener for responsive adjustments
    window.addEventListener('resize', this.debounce(() => {
      this.handleResize();
    }, 150));
  }

  processLiquidOutputs() {
    // Find and process any dynamic elements that might need initialization
    const forms = this.container.querySelectorAll('form');
    forms.forEach(form => {
      if (!form.hasAttribute('data-processed')) {
        // Add any form handling logic here
        form.setAttribute('data-processed', 'true');
      }
    });
  }

  handleResize() {
    // Handle any responsive behavior beyond CSS
    const isMobile = window.innerWidth <= 768;
    const hideOnMobile = this.section.hasAttribute('data-hide-mobile');
    const hideOnDesktop = this.section.hasAttribute('data-hide-desktop');

    if ((hideOnMobile && isMobile) || (hideOnDesktop && !isMobile)) {
      this.section.style.display = 'none';
    } else {
      this.section.style.display = '';
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize sections when they load (for Shopify's dynamic sections)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.custom-liquid-section').forEach(section => {
    if (!section.dataset.initialized) {
      new CustomLiquidSection(section);
      section.dataset.initialized = 'true';
    }
  });
});

// Re-initialize when Shopify dynamically adds sections (Ajax cart, quick shop, etc.)
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.detail.section;
    if (section.classList && section.classList.contains('custom-liquid-section')) {
      new CustomLiquidSection(section);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
